import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faCheckCircle, faThermometerHalf } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { HeadingItem } from 'components'
import { TripContext } from 'contexts'
import React, { FC, Fragment, useContext } from 'react'
import { LicensePlate, LicensePlateItem, Order, OrderItem, OrderLicensePlate } from 'services/types'
import { IconOptions } from 'types'
import './lp-card.scss'

type Props = {
    lpId: number
}

export const LpCard: FC<Props> = ({ lpId }) => {

    const tripContext = useContext(TripContext)

    const lp: LicensePlate = tripContext.licensePlates.find(lp => lp.id === lpId) ?? {} as LicensePlate
    const orderLps: OrderLicensePlate[] = tripContext.orderLicensePlates.filter(lpo => lpo.licensePlateId == lp.id)
    const lpItems: LicensePlateItem[] = tripContext.licensePlateItems.filter(lpi => lpi.licensePlateId === lpId)
    const lpOrders: Order[] = tripContext.orders.filter(o => orderLps.some(olp => olp.orderId == o.id))
    const orderItems: OrderItem[] = tripContext.orderItems.filter((oi: OrderItem) => lpOrders.some(o => o.id == oi.orderId) && lpItems.some(lpi => lpi.lineItemId == oi.lineItemId)) ?? []

    let itemsVerified = orderItems.filter(item => item.verifiedMethod !== null)
    let itemsNotVerified = orderItems.filter(item => item.verifiedMethod === null)
    let rightHandIconDetails: IconOptions = { icon: faCheckCircle, size: '2x', color: '#76AB21' }

    return (
        <div className={'search-result-card-material'}>
            <HeadingItem text={`LP: ${lpId.toString()}`} rightHandIcon={lp.verifiedMethod != null ? rightHandIconDetails : undefined} />
            <div className={'lp-card-content-container'}>
                <div className={'list-subheading'}>Not Verified : {itemsNotVerified.length}</div>
                <div className={'list-subheading'}>Verified : {itemsVerified?.length}</div>
                <div className={'item-card-content-temperature'}>
                    {lp.temperature &&
                        <Fragment>
                            <FontAwesomeIcon icon={faThermometerHalf as IconProp} color='Red' size='1x' />
                            <div className={'list-subheading'} style={{ paddingLeft: "10px" }}>{lp.temperature}</div>
                        </Fragment>
                    }
                </div>
            </div>
        </div>
    )
}
